export function CombavaSpinner({ className = "size-8", color = "text-primary" }: { className?: string, color?: string }) {
  return (
    <div className={`relative ${className} ${color}`}>
      <svg viewBox="0 0 100 100" fill="currentColor" className="w-full h-full">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
          <path
            key={i}
            d="M50 50 L35 12 A 16.5 16.5 0 0 1 65 12 Z"
            transform={`rotate(${i * 45} 50 50)`}
            className="animate-spinner-fade"
            style={{ animationDelay: `${i * 150}ms`, opacity: 0.1 }}
          />
        ))}
      </svg>
    </div>
  );
}
